import deriveLinkComponents from '../associations/derive-link-components';
import api from '../REST/api';
import MerchantLink from './MerchantLink';

const { Link, Links } = deriveLinkComponents(
  MerchantLink,
  api.getZMSAMMerchant,
);

export { Link as MerchantLink, Links as MerchantLinks };
